<template>
  <section class="vacancy-edit-main">
    <div class="vacancy-edit-main__section">
      <TranslateFiled :value="inputs.title.value"
                      :title="$tNewVacancy('Vacancy title')"
                      :required="inputs.title.required"
                      :error="inputs.title.error"
                      id="vacancy-title"
                      @input="onInput('title', $event)"
                      class="vacancy-edit-main__item"/>
      <div id="vacancy-field-of-activity"
           class="vacancy-edit-main__item  vacancy-edit-main__direction-wrap">
        <div class="vacancy-edit-main__direction">
          <h3 class="vacancy-edit-main__item-title">{{$tNewVacancy('Field of activity')}}</h3>
          <SDirection :value="inputs.direction_id.value"
                      :cancelable="false"
                      @input="onDirectionInput"
                      :placeholder="$tNewVacancy('Field of activity input')"
                      @initInput="onDirectionInput($event, true)"
                      preload/>
        </div>
        <div class="vacancy-edit-main__category">
          <div class="vacancy-edit-main__item-title" style="opacity: 0;">-</div>
          <SCategory :value="inputs.category_id.value"
                     :directionId="inputs.direction_id.value && inputs.direction_id.value.id"
                     :required="inputs.category_id.required"
                     :error="inputs.category_id.error"
                     :cancelable="false"
                     :placeholder="$tNewVacancy('Profession')"
                     @setValue="onCategoryInput($event, false)"
                     @input="onCategoryInput"
                     preload/>
        </div>
      </div>
      <VacancyEditMedia v-if="windowSizeMixin.width < 1024"
                        class="vacancy-edit-main__item"/>
      <!--      <div  id="vacancy-job-types" class="vacancy-edit-main__item">-->
      <!--        <TranslateFiled :value="jobTypes.job_types"-->
      <!--                        @input="setJobTypeInput"-->
      <!--                        :title="$tNewVacancy('Job types')"-->
      <!--                        multiple/>-->
      <!--      </div>-->
      <!--      <button @click.prevent="onAddJobType"-->
      <!--              class="base-btn  base-btn&#45;&#45;outline-grey  base-btn&#45;&#45;small">-->
      <!--        <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem"/>-->
      <!--        <span>{{$tNewVacancy('Add job type')}}</span>-->
      <!--      </button>-->
    </div>
    <div class="vacancy-edit-main__section">
      <h3 class="vacancy-edit-main__item-title">{{$tNewVacancy('Number of vacancies')}}</h3>
      <div class="vacancy-edit-main__item">
        <Amount :value="inputs.count.value"
                :required="inputs.count.required"
                :error="inputs.count.error"
                @input="onInput('count', $event)"
                :max="100"/>
      </div>
    </div>
    <div id="vacancy-salary" class="vacancy-edit-main__section">
      <h3 class="vacancy-edit-main__item-title">
        {{$tNewVacancy('Salary')}}
        <BaseSelect :value="computedSalaryType"
                    :options="salaryTypes"
                    textKey="name"
                    @input="onSalaryInput('salary_type', $event)"
                    style="width: 13rem"
                    :getOptionText="getOptionTextForSalary"
                    class="vacancy-edit-main__item-title-select  _shadow"/>
        {{$tNewVacancy('currency')}}
        <BaseSelect :value="computedCurrency"
                    :options="currencies"
                    textKey="symbol"
                    @input="onSalaryInput('currency_id', $event)"
                    style="width: 6rem"
                    class="vacancy-edit-main__item-title-select  _shadow"/>
      </h3>
      <div class="vacancy-edit-main__item">
        <BaseCheckbox :checked="isSalaryFixed"
                      @input="onSalaryChangeInput"
                      :label="$tNewVacancy('Set fix salary')"/>
      </div>
      <SliderRange v-if="isSalaryFixed"
                   :key="1"
                   :value="[salaryInputs.salary_fix.value || 0]"
                   :min="salaryMin"
                   :max="salaryMax"
                   @input="onSalaryFixedInput"
                   class="vacancy-edit-main__item  vacancy-edit-main__salary"/>
      <SliderRange v-else
                   :key="2"
                   :value="[salaryInputs.salary_from.value || 0, salaryInputs.salary_to.value || salaryMax]"
                   :min="salaryMin"
                   :max="salaryMax"
                   :fromName="$tNewVacancy('from')"
                   :toName="$tNewVacancy('to')"
                   @input="onSalaryRangeInput"
                   class="vacancy-edit-main__item  vacancy-edit-main__salary"/>

      <Note class="vacancy-edit-main__item">
        <p>{{$tNewVacancy('salary note')}}</p>
      </Note>

      <div class="vacancy-edit-main__item">
        <button v-if="!isShowCommentComputed"
                @click.prevent="onAddComment"
                class="base-btn  base-btn--outline-grey base-btn--small">
          <BaseSvg name="ico-comment"
                   width="1.3rem"
                   height="1.4rem"
                   style="position: relative; top: 0.1rem"/>
          <span>{{$tNewVacancy('Add a comment')}}</span>
        </button>
        <TranslateFiled v-else
                        v-model="salaryInputs.salary_comment.value"
                        :label="$tNewVacancy('Comment')"
                        textarea
                        rows="5"
                        withFullDelete
                        @input="onInput('salary_comment', $event)"
                        @delete="onDeleteComment('salary_comment')"/>
      </div>

      <div id="vacancy-start-date" class="vacancy-edit-main__item">
        <div class="vacancy-edit-main__item-head">
          <h3 class="vacancy-edit-main__item-title">{{$tNewVacancy('Start date')}}</h3>
          <BaseCheckbox :checked="isStartDateFixed"
                        @input="oniStartDateChangeInput"
                        :label="$tNewVacancy('Set exact date')"
                        class="vacancy-edit-main__item-head-checkbox"/>
        </div>
        <div v-if="isStartDateFixed" class="vacancy-edit-main__row">
          <div class="vacancy-edit-main__col  vacancy-edit-main__date-name-wrap">
            <DatePiker :value="inputs.job_start_date.value && inputs.job_start_date.value[0]"
                       :required="inputs.job_start_date.required"
                       :error="inputs.job_start_date.error"
                       :disabled-date="notBeforeToday"
                       :prefix="$tNewVacancy('from')"
                       @input="onStartDateFixedInput"/>
          </div>
        </div>
        <div v-else class="vacancy-edit-main__row">
          <div class="vacancy-edit-main__col  vacancy-edit-main__date-name-wrap">
            <DatePiker :value="inputs.job_start_date.value && inputs.job_start_date.value[0]"
                       :disabled-date="notBeforeToday"
                       :prefix="$tNewVacancy('from')"
                       @input="onStartDateFromInput"/>
          </div>
          <div class="vacancy-edit-main__col  vacancy-edit-main__date-name-wrap">
            <DatePiker :value="inputs.job_start_date.value && inputs.job_start_date.value[1]"
                       :disabled-date="disabledStartDateTo"
                       :prefix="$tNewVacancy('to')"
                       @input="onStartDateToInput"/>
          </div>
        </div>
      </div>
      <div id="vacancy-job-duration" class="vacancy-edit-main__item">
        <h3 class="vacancy-edit-main__item-title">{{$tNewVacancy('Job duration')}}</h3>
        <div class="vacancy-edit-main__row">
          <div class="vacancy-edit-main__col">
            <BaseSelect :value="inputs.job_duration.value"
                        :required="inputs.job_duration.required"
                        :error="inputs.job_duration.error"
                        text-key="name"
                        cancelable
                        :options="jobDurationList"
                        @input="onInput('job_duration', $event)"
                        class="_shadow"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="vacancy-edit-main__section">
      <div class="vacancy-edit-main__item">
        <h3 class="vacancy-edit-main__item-title">{{$tNewVacancy('Relevant until')}}</h3>
        <div class="vacancy-edit-main__row">
          <div class="vacancy-edit-main__col">
            <DatePiker :value="inputs.relevant_until.value"
                       :required="inputs.relevant_until.required"
                       :error="inputs.relevant_until.error"
                       @input="onInput('relevant_until', $event)"/>
            <BaseHelp :value="$tNewVacancy('relevant until help')"/>
          </div>
        </div>
      </div>
    </div>
    <div class="vacancy-edit-main__section">
      <TranslateFiled :value="inputs.description.value"
                      :required="inputs.description.required"
                      :error="inputs.description.error"
                      :title="$tNewVacancy('Description')"
                      editor
                      @input="onInput('description', $event)"
                      class="vacancy-edit-main__description"/>
    </div>
  </section>
</template>

<script>
  import {mapState} from 'vuex'
  import TranslateFiled from './TranslateFiled'
  import SDirection from './loadingSelects/SDirection'
  import SCategory from './loadingSelects/SCategory'
  import Amount from './Amount'
  import SliderRange from './SliderRange'
  import Note from './Note'
  import DatePiker from './DatePiker'
  import formMixins from '../mixins/formMixins'
  import VacancyEditMedia from "./VacancyEditMedia";
  import windowSizeMixin from "../mixins/windowSizeMixin";

  const today = new Date();

  export default {
    mixins: [formMixins, windowSizeMixin],
    components: {
      VacancyEditMedia,
      TranslateFiled,
      SDirection,
      SCategory,
      Amount,
      SliderRange,
      Note,
      DatePiker
    },
    data() {
      return {
        title: null,

        free_work_places: 1,
        salary_type: null,
        currency: null,
        isSalaryFixed: false,
        salaryFixed: [0],
        salaryMin: 0,
        salaryMax: 100000,
        salary: [0, 100000],
        isShowComment: false,
        isStartDateFixed: false,
        startDateFrom: null,
        startDateTo: null,
        startDateFixed: null,
      }
    },
    computed: {
      ...mapState('vacancyEdit/main/', [
        'muted',
        'inputs',
        'jobDurationList',
        'jobTypes',
        'salaryInputs',
      ]),
      salaryTypes() {
        return this.$store.state.salaryTypes
      },
      computedSalaryType() {
        return this.salaryInputs.salary_type.value || this.salaryTypes[0]
      },
      currencies() {
        return this.$store.state.currencies
      },
      computedCurrency() {
        return this.salaryInputs.currency_id.value || this.$store.state.currentCurrency || this.currencies[0]
      },
      isShowCommentComputed() {
        return this.isShowComment || this.salaryInputs.salary_comment.value
      },
    },
    methods: {
      onAddJobType() {
        let types = JSON.parse(this.jobTypes.job_types)
        types.push({})

        this.setJobTypeInput(JSON.stringify(types))
      },
      onSalaryChangeInput(isChecked) {
        if (isChecked) {
          this.onSalaryInput('salary_from', null)
          this.onSalaryInput('salary_to', null)
        } else {
          this.onSalaryInput('salary_fix', null)
        }

        this.isSalaryFixed = isChecked
      },
      oniStartDateChangeInput(isChecked) {
        this.onInput('job_start_date', null)

        this.isStartDateFixed = isChecked
      },
      onAddComment() {
        this.isShowComment = true
      },
      onDeleteComment(key) {
        this.isShowComment = false
        this.onInput(key, null)
      },
      onStartDateFromInput(value) {
        let newRange

        if (Array.isArray(this.inputs.job_start_date.value)) {
          newRange = [...this.inputs.job_start_date.value]
        } else {
          newRange = []
        }


        if (!value || isNaN(value)) {
          newRange[0] = null
          return this.onInput('job_start_date', newRange)
        }

        if (value < today) {
          value = today
        }

        if (newRange[1] && value > newRange[1]) {
          let nextDate = new Date(value)
          nextDate.setDate(nextDate.getDate() + 1)
          newRange[1] = nextDate
        }

        newRange[0] = value

        this.onInput('job_start_date', newRange)
      },
      onStartDateToInput(value) {
        let newRange

        if (Array.isArray(this.inputs.job_start_date.value)) {
          newRange = [...this.inputs.job_start_date.value]
        } else {
          newRange = []
        }

        if (value < today) {
          value = today
        }

        if (newRange[0] && value < newRange[0]) {
          let nextDate = new Date(value)
          nextDate.setDate(nextDate.getDate() + 1)
          newRange[1] = nextDate
        }

        newRange[1] = value

        this.onInput('job_start_date', newRange)
      },
      onStartDateFixedInput(value) {
        let ms = +value
        if (ms < today) {
          value = today
        }

        if (!ms || isNaN(ms)) {
          return this.inputs.job_start_date.value = null
        }

        this.inputs.job_start_date.value = [value]
      },
      notBeforeToday(date) {
        return date < today;
      },
      disabledStartDateTo(date) {
        return date < today ||
          this.inputs.job_start_date.value && this.inputs.job_start_date.value[0] && date < this.inputs.job_start_date.value[0];
      },
      resetErrors() {
        this.resetErrorsMix(this.inputs)
      },
      getJobTypes() {
        return this.jobTypes
      },
      getJobSalary() {
        const inputs = this.salaryInputs

        inputs.salary_fix.value = this.salaryFixed[0]
        inputs.salary_from.value = this.salary[0]
        inputs.salary_to.value = this.salary[1]

        return this.createSendDataMix(inputs)
      },
      onDirectionInput(value, isInit) {
        this.onInput('direction_id', value)
        if (!isInit) this.onCategoryInput(null)
      },
      onCategoryInput(value, withReset = true) {
        const params = value && value.params ? value.params : []

        if (shouldDirectionChange(value, this.inputs.direction_id.value)) {

          this.onInput('direction_id', value.category.direction_id)
        }

        if (withReset) {
          this.$store.commit('vacancyEdit/characteristicsDynamicParams/resetState')
          if (this.$route.params.categoryId) {
            this.$store.commit('vacancyEdit/characteristicsDynamicParams/setMuted', true)
          }
        }
        this.$store.commit('vacancyEdit/characteristicsDynamicParams/setParamsList', params)
        this.onInput('category_id', value)
      },
      setJobTypeInput(value) {
        this.$store.commit('vacancyEdit/main/setJobTypeValue', value)
      },
      onInput(key, value) {
        this.$store.commit('vacancyEdit/main/setInputValue', {key, value})
      },
      onSalaryFixedInput(value) {
        this.onSalaryInput('salary_fix', value[0])
      },
      onSalaryRangeInput(value) {
        this.onSalaryInput('salary_from', value[0])
        this.onSalaryInput('salary_to', value[1])
      },
      onSalaryInput(key, value) {
        this.$store.commit('vacancyEdit/main/setSalaryValue', {key, value})
      },
      getOptionTextForSalary(option) {
        return option ? this.$tGlobal(option.name) : null
      }
    },
    created() {
      this.$store.dispatch('vacancyEdit/main/load')

      if (!this.salaryInputs.salary_type.value) {
        this.onSalaryInput('salary_type', this.computedSalaryType)
      }

      if (!this.salaryInputs.currency_id.value) {
        this.onSalaryInput('currency_id', this.computedCurrency)
      }

      if (this.salaryInputs.salary_fix.value) {
        this.isSalaryFixed = true
      }

      if (this.inputs.job_start_date.value && this.inputs.job_start_date.value.length < 2) {
        this.isStartDateFixed = true
      }
    }
  }


  function shouldDirectionChange(category, direction) {
    if (!category || !category.category || !category.category.direction_id) return false

    if (!direction) return true
    return direction.id !== category.category.direction_id
  }
</script>

<style lang="less">

</style>
